import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpService } from 'src/app/modules/shared/services/http/http.service';
import { liquidationUrl, liquidationDetailUrl, liquidationApproverUrl, itineraryLQUrl, itineraryDeleteUrl } from 'src/app/modules/shared/common/api';

@Injectable()
export class TravelLiquiditionService extends HttpService {

  constructor(http: HttpClient) { 
    super('',http);
  }
 
  getFilter() {
    return this.get().map(res => {
      return res['data'];
    }); 
  }

  storeLiquidation(data){
    return this.http.post(liquidationUrl, data).map((dataResponse) => {
      return dataResponse;
    });
   }

   updateLiquidation(id,data) {
    return this.http.put(liquidationUrl + '/' + id , data).map((dataResponse) => {
      return dataResponse;
    });
   }
  
   updateStatus(id,data) {
    return this.http.put(liquidationUrl + '/status/' + id , data).map((dataResponse) => {
      return dataResponse;
    });
   }

   storeDetail(data){
    return this.http.post(liquidationDetailUrl, data).map((dataResponse) => {
      return dataResponse;
    });
   }

   updateDetail(id,data) {
    return this.http.put(liquidationDetailUrl + '/' + id , data).map((dataResponse) => {
      return dataResponse;
    });
   }

  approverUpdateStatus(id,data) {
    return this.http.put(liquidationApproverUrl + '/status/' + id , data).map((dataResponse) => {
      return dataResponse;
    });
  }

  deleteliquidation(data) {
    return this.http.put(itineraryDeleteUrl, data).map((dataResponse) => {
      return dataResponse;
    });
  }
 
 
 }